

//Formatea el Numero en Miles
export const formatNumber = (num) => {

    if(num != null && num != undefined)
    {
        num = num + ''; // Número a cadena
        var str = ""; // Acumulación de cadenas
        for (var i = num.length - 1, j = 1; i >= 0; i--, j++) {
            if (j % 3 == 0 && i != 0) {// Se agrega una coma cada tres dígitos para filtrar el caso donde es exactamente el primer dígito
                str += num[i] + "."; // Agrega una coma de miles
                continue;
            }
            str += num[i]; // Para acumular números al revés
        }
        return str.split('').reverse().join(""); // String => Array => Reverse => String
    }
    else
    {
        return "0";
    }
};